// admin.product.service.js
// TEMPORARY: Direct Firebase imports
import { 
  getFirestore, 
  collection, 
  getDocs, 
  query, 
  orderBy,
  doc,
  updateDoc,
  deleteDoc,
  serverTimestamp 
} from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Initialize Firebase (you might already have this elsewhere)
// import { initializeApp } from 'firebase/app';
// import firebaseConfig from './firebaseConfig';

class AdminProductService {
  // Use a singleton pattern for Firebase instances
  static getDb() {
    // If you already have firebase initialized elsewhere, use that
    // Otherwise, initialize here
    // const app = initializeApp(firebaseConfig);
    // return getFirestore(app);
    
    // Or if firebase is already initialized globally
    return getFirestore();
  }

  static async getAllProducts() {
    try {
      console.log('🔄 AdminProductService: Fetching all products...');
      
      const db = this.getDb();
      const productsRef = collection(db, 'products');
      const q = query(productsRef, orderBy('createdAt', 'desc'));
      const snapshot = await getDocs(q);
      
      console.log(`📊 Firestore snapshot size: ${snapshot.size}`);
      
      const products = [];
      snapshot.forEach((doc) => {
        const data = doc.data();
        products.push({
          id: doc.id,
          ...data,
          // Ensure dates are properly formatted
          createdAt: data.createdAt?.toDate?.() || data.createdAt,
          updatedAt: data.updatedAt?.toDate?.() || data.updatedAt
        });
      });
      
      console.log('✅ Products processed:', products.length);
      return products;
    } catch (error) {
      console.error('❌ Error in getAllProducts:', error);
      throw error;
    }
  }


  // Add this method to your admin.product.service.js
static async getProductById(productId) {
  try {
    console.log(`📋 Fetching product by ID: ${productId}`);
    
    // Import Firestore functions
    const { db, doc, getDoc } = await import('../../../firebase/config');
    
    const productRef = doc(db, 'products', productId);
    const productDoc = await getDoc(productRef);
    
    if (!productDoc.exists()) {
      throw new Error('Product not found');
    }
    
    const data = productDoc.data();
    return {
      id: productDoc.id,
      ...data,
      createdAt: data.createdAt?.toDate?.() || data.createdAt,
      updatedAt: data.updatedAt?.toDate?.() || data.updatedAt,
      approvedAt: data.approvedAt?.toDate?.() || data.approvedAt,
      rejectedAt: data.rejectedAt?.toDate?.() || data.rejectedAt
    };
  } catch (error) {
    console.error(`❌ Error fetching product ${productId}:`, error);
    throw error;
  }
}


  static async approveProduct(productId) {
    try {
      const db = this.getDb();
      const productRef = doc(db, 'products', productId);
      
      await updateDoc(productRef, {
        status: 'APPROVED',
        updatedAt: serverTimestamp(),
        approvedAt: serverTimestamp()
      });
      
      console.log(`✅ Product ${productId} approved`);
    } catch (error) {
      console.error('❌ Error approving product:', error);
      throw error;
    }
  }

  static async rejectProduct(productId, reason) {
    try {
      const db = this.getDb();
      const productRef = doc(db, 'products', productId);
      
      await updateDoc(productRef, {
        status: 'REJECTED',
        rejectionReason: reason,
        updatedAt: serverTimestamp(),
        rejectedAt: serverTimestamp()
      });
      
      console.log(`✅ Product ${productId} rejected`);
    } catch (error) {
      console.error('❌ Error rejecting product:', error);
      throw error;
    }
  }

  static async deleteProduct(productId) {
    try {
      const db = this.getDb();
      const productRef = doc(db, 'products', productId);
      
      await deleteDoc(productRef);
      
      console.log(`✅ Product ${productId} deleted`);
    } catch (error) {
      console.error('❌ Error deleting product:', error);
      throw error;
    }
  }
}

export default AdminProductService;